import { render, staticRenderFns } from "./SalesOrderDetailMutiSelect.vue?vue&type=template&id=197bca3b&"
import script from "./SalesOrderDetailMutiSelect.vue?vue&type=script&lang=js&"
export * from "./SalesOrderDetailMutiSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports